import { z } from 'zod'
import { makeFieldKeys } from '../../core/utils/utilities.ts'

export const UserPreferenceReportModelSchema = z
  .object({
    id: z.string(),
    user_id: z.string(),
    menu_item_id: z.string(),
    report_id: z.string().nullish(),
    data: z.record(z.string(), z.unknown())
  })
  .strict()

const UserPreferenceReportModelFields = makeFieldKeys(UserPreferenceReportModelSchema)

export type UserPreferenceReportModel = z.infer<typeof UserPreferenceReportModelSchema>
